import script from "./UserFullNameCell.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserFullNameCell.vue?vue&type=script&setup=true&lang=ts"

import "./UserFullNameCell.vue?vue&type=style&index=0&id=637d49a3&lang=scss"

const __exports__ = script;

export default __exports__